import "../../../styles/hubweb/overview.scss";

import { HubTab, HubTabList, HubTabPanel, HubTabs } from "./HubTabs.jsx";

import CustomerList from "./CustomerList.jsx";
import { Localization } from "../../common/util/localization.jsx";
import PropTypes from "prop-types";
import React from "react";
import { scssVariables } from "../../common/util/config.jsx";
import { withRouter } from "react-router-dom";

class ProductionCard extends React.PureComponent {
    constructor(props) {
        super(props);

        this.swallowOnClick = this.swallowOnClick.bind(this);
        this.tabClick = this.tabClick.bind(this);
    }

    swallowOnClick(event) {
        event.stopPropagation();
        event.preventDefault();
    }

    calculateInternalPanelHeight() {
        let tabPanelHeight = this.props.height;

        // Remove height of tab panel
        tabPanelHeight -= parseInt(scssVariables.menuHeightWithBorder) + 45;
        return tabPanelHeight;
    }

    tabClick(e, index) {
        e.stopPropagation();
        
        this.setState({
            tabIndexSelected: index,
        });

    }

    render() {
        const {
            height,
            localization,
            setModal,
            width,
            customers,
            createAddressLabels,
            updateNoOfDollies,
            creating,
            loading,
            selectCustomer,
            getOrdersForDoughProducts,
        } = this.props;

        const tabPanelHeight = this.calculateInternalPanelHeight();

        return (
            <div className={"card-default"} style={{ display: "flex", flexDirection: "column", height: `${height-200}px`, width: `${width}px` }}>
                <HubTabs startTabId={0} tabClick={this.tabClick}>                    
                    <HubTabList>
                        <HubTab id={"1"} key={1} label={"Ubehandlet"} />
                        <HubTab id={"2"} key={2} label={"Behandlet"} />
                    </HubTabList>
                    <HubTabPanel key={1}>
                        <CustomerList
                            height={tabPanelHeight}
                            width={width}
                            customers={customers.untreatedCustomers}
                            localization={localization}
                            setModal={setModal}
                            createAddressLabels={createAddressLabels}
                            updateNoOfDollies={updateNoOfDollies}
                            treated={false}
                            creating={creating}
                            loading={loading}
                            selectCustomer={selectCustomer}
                            normalCratesAlias={customers.normalCratesAlias}
                            mediumCratesAlias={customers.mediumCratesAlias}
                            smallCratesAlias={customers.smallCratesAlias}
                            getOrdersForDoughProducts ={getOrdersForDoughProducts}
                        />
                    </HubTabPanel>
                    <HubTabPanel key={2}>
                        <CustomerList
                            height={tabPanelHeight}
                            width={width}
                            customers={customers.treatedCustomers}
                            localization={localization}
                            setModal={setModal}
                            createAddressLabels={createAddressLabels}
                            updateNoOfDollies={updateNoOfDollies}
                            treated={true}
                            creating={creating}
                            loading={loading}
                            selectCustomer={selectCustomer}
                            normalCratesAlias={customers.normalCratesAlias}
                            mediumCratesAlias={customers.mediumCratesAlias}
                            smallCratesAlias={customers.smallCratesAlias}
                        />
                    </HubTabPanel>
                </HubTabs>
                
            </div>
        );
    }
}

ProductionCard.propTypes = {
    deviceType: PropTypes.string.isRequired,
    height: PropTypes.number.isRequired,
    localization: Localization.propTypes.isRequired,
    location: PropTypes.object.isRequired,
    setModal: PropTypes.func.isRequired,
    width: PropTypes.number.isRequired,
    customers: PropTypes.object.isRequired,
    createAddressLabels: PropTypes.func.isRequired,
    updateNoOfDollies: PropTypes.func.isRequired,
    creating: PropTypes.bool.isRequired,
    loading: PropTypes.bool.isRequired,
    selectCustomer: PropTypes.func.isRequired,
    getOrdersForDoughProducts:  PropTypes.func.isRequired,
};

ProductionCard.defaultProps = {
    currentView: "all",
};
export default withRouter(ProductionCard);
